import { BasicModal, ToastType } from '@components';
import {
  deleteSavedSearch,
  loadBoardStore,
  SavedSearchT,
} from '@store/loadboard';
import { deleteFilter } from '@store/loadboard/services';
import { DeleteIcon } from '@atgfr8/icons';
import {
  Box,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@atgfr8/atg-ui-tailwind';
import { createError } from '@utils/errorUtils';
import { handleToast } from '@utils/utils';
import { Component, createSignal, For, Show } from 'solid-js';

type PropsT = {
  id: string;
  onCloseModal: (label: string) => void;
};

export const ManageModal: Component<PropsT> = (props: PropsT) => {
  const [loadingId, setLoadingId] = createSignal<number | null>(null);
  const onDeleteFilter = async (search: SavedSearchT) => {
    try {
      setLoadingId(search.id);
      const success = await deleteFilter(search);
      if (success) {
        deleteSavedSearch(search);
      }
    } catch (err) {
      const e = createError(err, 'Failed to delete filter');
      handleToast(ToastType.Error, e.message);
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <BasicModal
      title="My Saved Templates"
      id={props.id}
      onClose={() => props.onCloseModal(props.id)}
      width="600px"
      maxWidth="600px"
      footer={false}
      showClose={true}
    >
      <Box
        style={{
          height: '300px',
          'overflow-y': 'auto',
        }}
        class="flex mb-3"
      >
        <div class="text-black! [&_td]:!border-[#e0e0e0] [&_th]:!border-[#e0e0e0] w-full">
          <Table>
            <TableBody>
              <For each={loadBoardStore.filters}>
                {(search) => {
                  return (
                    <TableRow>
                      <TableCell>{search.name}</TableCell>
                      <TableCell style={{ width: '60px' }}>
                        <IconButton
                          disabled={loadingId() === search.id}
                          onClick={() => onDeleteFilter(search)}
                          dataTestId={`manage-modal-delete-${search.id}`}
                        >
                          <Show
                            when={loadingId() === search.id}
                            fallback={<DeleteIcon size={20} />}
                          >
                            <CircularProgress
                              size={18}
                              aria-label="Deleting…"
                            />
                          </Show>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                }}
              </For>
            </TableBody>
          </Table>
        </div>
      </Box>
    </BasicModal>
  );
};
